import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MicrositesRoutingModule } from './microsites-routing.module';
import { MicrositesComponent } from './microsites.component'
import { MarketingService } from '../services/marketing.service';
import { SharedModule } from '../shared/shared.module';
import { MatSortModule } from '@angular/material/sort';
import { NgProgressModule } from 'ngx-progressbar';
import { ChildHeaderModule } from '../child-header/child-header.module';
import { BreadcrumbModule } from '../breadcrumb/breadcumb.module';


@NgModule({
  imports: [BrowserModule,
    CommonModule, 
    NgbModule,
    SharedModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    NgProgressModule,
    MatSortModule,
     RouterModule,
    MicrositesRoutingModule,
    ChildHeaderModule,
    BreadcrumbModule
    ],
  declarations: [
    MicrositesComponent
  ], 
  providers: [
    MarketingService
  ]
})
export class MicrositesModule {} 